import React from 'react';
import { Phone } from 'lucide-react';
export function RollUpDoorPartsPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4448">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4449">
        <div className="container mx-auto px-4" data-id="element-4450">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4451">
            Roll Up Door Parts
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-4452">
            Quality Parts for Roll Up Doors
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4453">
        <div className="max-w-4xl mx-auto" data-id="element-4454">
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4455">
            <p className="text-gray-700" data-id="element-4456">Content coming soon...</p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4457">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4458">Contact Us Today</h2>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4459">
              <Phone className="mr-3" size={24} data-id="element-4460" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4461">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}